import { motion } from "framer-motion";

function SectionBlock({ section, isLast }) {
  const paragraphs = section.paragraphs || (section.body ? [section.body] : []);
  const bullets = section.bullets || [];

  return (
    <div className={isLast ? "" : "border-b border-stone-100 pb-6"}>
      <h2 className="font-heading text-2xl text-charcoal">{section.title}</h2>

      {paragraphs.map((paragraph, index) => (
        <p key={`${section.title}-paragraph-${index}`} className="mt-3 font-body text-sm leading-relaxed text-stone-600">
          {paragraph}
        </p>
      ))}

      {bullets.length > 0 ? (
        <ul className="mt-3 list-disc space-y-2 pl-5 font-body text-sm leading-relaxed text-stone-600">
          {bullets.map((item, index) => (
            <li key={`${section.title}-bullet-${index}`}>{item}</li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

export default function LegalDocumentPage({
  title,
  lastUpdated,
  intro,
  sections,
  testIdPrefix,
}) {
  return (
    <div className="pb-mobile-bar" data-testid={`${testIdPrefix}-page`}>
      <section
        className="bg-stone-50 pt-10 pb-6 md:pt-14 md:pb-8 lg:pt-16 lg:pb-10"
        data-testid={`${testIdPrefix}-hero`}
      >
        <div className="container-luxury max-w-4xl">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-caption mb-3 text-accent-gold"
          >
            Legal
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-display mb-4"
          >
            {title}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-body"
          >
            Last updated: {lastUpdated}
          </motion.p>
          {intro ? (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-body mt-4"
            >
              {intro}
            </motion.p>
          ) : null}
        </div>
      </section>

      <section className="section-spacing" data-testid={`${testIdPrefix}-content`}>
        <div className="container-luxury max-w-4xl">
          <div className="space-y-6 rounded-3xl border border-stone-200 bg-white p-6 md:p-10">
            {sections.map((section, index) => (
              <SectionBlock key={section.title} section={section} isLast={index === sections.length - 1} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
